var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { class: ["mobile-city", { active: _vm.active }] }, [
    _c(
      "span",
      {
        staticClass: "link",
        on: {
          click: function($event) {
            return _vm.$f.showNav("city")
          }
        }
      },
      [
        _vm._v("\n    Ваш город\n    "),
        _c("em", [_vm._v(_vm._s(_vm.CITY.name))])
      ]
    ),
    _c(
      "div",
      { staticClass: "tree-menu depth2" },
      [
        _c(
          "vue-client-only",
          [
            _c("mobile-menu-header", {
              attrs: { title: "Выбор региона доставки", "show-back": "" },
              on: {
                back: function($event) {
                  $event.stopPropagation()
                  return _vm.$f.showNav()
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mobile-city-container" },
          [
            _vm.active
              ? _c("city-search", {
                  attrs: { locally: _vm.$f.navSection === "selectCity" },
                  on: { choose: _vm.changeCity }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }